import {OERenderMode} from '../../../../react-oe/oe-types';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import OEMainMenuBtnAdapter from './oe-main-menu-btn-adapter';

export default class OEMainMenuBtnAdapterComponent extends OEMainMenuBtnAdapter {

    constructor(componentId, renderMode) {
        super();

        this.componentId = typeof(componentId) === 'string' ? componentId : '';

        this.renderMode = typeof(renderMode) === 'number' ? renderMode : OERenderMode.transparent;

        this.state = {
            active:         false,
            enabled:        false
        };

        this.updateState = this.updateState.bind(this);
    }

    setState(state) {
        let newState = Object.assign({}, this.state, state);
        if(OEToolbox.shallowEqual(newState, this.state, true)) return;
        this.state = newState;
        if(this.menu) this.menu.updateForAdapter(this);
    }

    onConnect()  {
        this.updateState();
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.componentsRenderModeChanged, this.updateState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.updateState);
    }

    onRelease()  {
        this.updateState(true);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.componentsRenderModeChanged, this.updateState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.updateState);
    }

    isCoreActive()  {
        if(!this.oe || !this.oe.isReady() || !this.componentId)  return false;

        let comp = this.oe.sharedInterface.getUIControllerComponent();
        let renderMode = comp.getComponentRenderMode(this.componentId);

        return renderMode != this.oe.Module.RenderMode.opaque;
    }

    isCoreEnabled() {
        if(!this.oe || !this.oe.isReady() || !this.componentId)  return false;

        let comp = this.oe.sharedInterface.getUIControllerComponent();

        return comp.getUIEnabled();
    }

    updateState(released)   {
        if(!this.oe || !this.oe.isReady() || released === true)   {
            this.setState({active: false, enabled: false});
            return;
        }

        let isCoreActive = this.isCoreActive();
        let isCoreEnabled = this.isCoreEnabled();

        this.setState({
            active: isCoreEnabled && isCoreActive,
            enabled: isCoreEnabled
        });
    }

    onPressed(activated, menu)   {
        if(!this.state.enabled) return this.state.active;
        if(!this.oe || !this.oe.isReady()) return this.state.active;
        if(!this.isCoreEnabled() || !this.componentId)   return this.state.active;

        let comp = this.oe.sharedInterface.getUIControllerComponent();
        let renderMode = comp.getComponentRenderMode(this.componentId);
        comp.setComponentRenderMode(this.componentId, renderMode === this.oe.Module.RenderMode.opaque ? {value: this.renderMode} : this.oe.Module.RenderMode.opaque, true, 0.333);

        this.state.active = this.isCoreActive();
        return this.state.active;
    }

    isActive(menu)   {
        return this.state.active;
    }

    isEnabled(menu) {
        return this.state.enabled;
    }
}